import { UseQueryResult } from "react-query";
import { useState } from "react";
import { Box } from "@wealthx/ui/box";
import { Typography } from "@wealthx/ui/typography";
import { IconButton } from "@wealthx/ui/icon-button";
import { Close } from "@mui/icons-material";
import { useStaffCreationJobStatus } from "../../hooks/staff.hooks";
import "./staff-import-banner.scss";

const StaffImportBanner: React.FC = () => {
  const { data } = useStaffCreationJobStatus() as UseQueryResult<any, any>;
  const [errorDismissed, setErrorDismissed] = useState(false);

  if (!data) return null;

  const { hasPending, hasError } = data;

  return (
    <>
      {hasPending && (
        <Box className="staff-import-banner staff-import-banner--pending">
          <Typography className="staff-import-banner__text">
            We are importing your staff members. Please wait patiently...
          </Typography>
        </Box>
      )}

      {hasError && !hasPending && !errorDismissed && (
        <Box className="staff-import-banner staff-import-banner--error">
          <Typography className="staff-import-banner__text">
            Some staff members failed to import. You can add them manually in
            the Staff section, or contact our support team if this affects a
            large number of staff.
          </Typography>
          <IconButton
            size="small"
            onClick={() => setErrorDismissed(true)}
            className="staff-import-banner__close"
            aria-label="Dismiss"
          >
            <Close fontSize="small" />
          </IconButton>
        </Box>
      )}
    </>
  );
};

export default StaffImportBanner;
